export default {
  menu: {
    home: 'Home',
    bussinesscooperator: 'BussinessCooperator',
    advertisingplatform: 'Partnership',
    contactUS: 'Contact US',
    faq: 'FAQ',
    serviceIntro: 'Service Intro',
    usage: 'Usage',
    fee: 'Fee',
    brands: 'Brands'
    },
  home: {
    title: 'Welcome to Our Platform',
    intro: 'This is an introduction in English.'
  },
  bussinesscooperator: {
    title: 'Latest BussinessCooperator',
    content: 'Here are the latest updates.'
  },
  faq: {
    title: 'Frequently Asked Questions',
    q1: 'How to use this site?'
  }

}
